// apolo/src/lib/loop/ranChecksGate.js — BET 1 (code-tab-to-10).
// @arch:pure-engine
//
// PURE gate: decides whether a done-claim should be re-steered because no
// check (test/lint/build) ran this turn. Extracted from the spine to keep
// the DP/LOC ratchet flat — the spine delegates here instead of inlining
// the logic.

import { ranChecks } from '../gate.js';
import { deriveCheckCommands } from '../spinePredicates.js';
import { readRanChecksGateEnabled } from '../../flags/sprintFlags.js';

export const RAN_CHECKS_NUDGE = [
  '[NUDGE] Você editou código mas não rodou nenhuma verificação (teste/lint/build) neste turno.',
  'Rode um check (ex.: run_command com "npm test", "npm run lint", "npx tsc --noEmit")',
  'e relate o resultado real antes de concluir — ou, se a mudança é trivial, confirme explicitamente.',
].join(' ');

/**
 * Decide whether the ranChecks gate should re-steer (nudge) or let the done pass.
 * Reads the feature flag internally so the spine stays flat.
 *
 * @param {object} s — SpineState (needs: wroteFile, committed, ranChecksNudged,
 *                     convo, toolNameById, toolArgsById)
 * @returns {boolean} — true to re-steer, false to pass.
 */
export function ranChecksGate(s) {
  if (!readRanChecksGateEnabled() || !s.wroteFile || s.committed || s.ranChecksNudged) return false;
  const checkCmds = deriveCheckCommands(s.convo, s.toolNameById, s.toolArgsById);
  return ranChecks({ checkCommands: checkCmds }).verdict !== 'pass';
}
